module.exports = __webpack_public_path__ + "static/media/icon_inserat_schreiben.f11151a2.png";